module.exports = __webpack_public_path__ + "img/ip11.3cc95687.png";